import { PasswordValidation } from "./PasswordValidation";
import { EmailValidation } from "./MultipleValidations";

export function AddUserFormValidation(inputValue: any, setState: any) {
  const res = "dd";

  // Generic field validator
  const validateField = (field: string, value: any, message: string) => {
    if (!value || value.trim().length === 0) {
      setState((prev: any) => ({
        ...prev,
        [field]: { error: true, message },
      }));
      return false;
    } else {
      setState((prev: any) => ({
        ...prev,
        [field]: { error: false, message: "" },
      }));
      return true;
    }
  };

  // ===== Email =====
  if (!validateField("email", inputValue.email, "Add Your Email Address")) {
    // skip format check if empty
  } else if (!EmailValidation(inputValue.email)) {
    setState((prev: any) => ({
      ...prev,
      email: { error: true, message: "Invalid Email" },
    }));
  }

  // ===== Simple Required Fields =====
  validateField("firstName", inputValue.firstName, "Add Your First Name");
  validateField("lastName", inputValue.lastName, "Add Your Last Name");
  validateField("jobTitle", inputValue.jobTitle, "Add Your Job Title");
  validateField("companyName", inputValue.companyName, "Add Your Company Name");

  // ===== Universal Mobile Number Validation =====
  const mobileRegex = /^\+?[1-9]\d{6,14}$/;

  if (
    !validateField(
      "mobileNumber",
      inputValue.mobileNumber,
      "Add Your Mobile Number"
    )
  ) {
    // skip more checks if empty
  } else if (!mobileRegex.test(inputValue.mobileNumber)) {
    setState((prev: any) => ({
      ...prev,
      mobileNumber: {
        error: true,
        message:
          "Enter a valid mobile number (7–15 digits, optional + allowed)",
      },
    }));
  }

  return res;
}

export function ForgotPasswordValidation(
  inputValue: any,
  inputErrorValues: any,
  setState: any
) {
  if (inputValue.email.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["email"]: { error: true, message: "Add Your Email Address" },
    }));
  } else {
    if (!EmailValidation(inputValue.email)) {
      setState((prev: any) => ({
        ...prev,
        ["email"]: { error: true, message: "Invalid Email" },
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        ["email"]: { error: false, message: "" },
      }));
    }
  }
  return "ss";
}

export function LoginValidation(
  inputValue: any,
  inputErrorValues: any,
  setState: any
) {
  if (inputValue.email.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["email"]: { error: true, message: "Add Your Email Address" },
    }));
  } else {
    if (!EmailValidation(inputValue.email)) {
      setState((prev: any) => ({
        ...prev,
        ["email"]: { error: true, message: "Invalid Email" },
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        ["email"]: { error: false, message: "" },
      }));
    }
  }

  if (inputValue.password.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["password"]: { error: true, message: "Add Your Password" },
    }));
  } else {
    if (!PasswordValidation(inputValue.password)) {
      setState((prev: any) => ({
        ...prev,
        ["password"]: {
          error: true,
          message:
            "Your Password must include One Capital letter, One Simple letter, One Special character & One numeric character",
        },
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        ["password"]: { error: false, message: "" },
      }));
    }
  }
  let res = "dd";
  return res;
}

export function SignUpValidation(
  inputValue: any,
  inputErrorValues: any,
  setState: any
) {
  let res = "dd";
  if (inputValue.email.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["email"]: { error: true, message: "Add Your Email Address" },
    }));
  } else {
    if (!EmailValidation(inputValue.email)) {
      setState((prev: any) => ({
        ...prev,
        ["email"]: { error: true, message: "Invalid Email" },
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        ["email"]: { error: false, message: "" },
      }));
    }
  }

  if (inputValue.firstName.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["firstName"]: { error: true, message: "Add Your First Name" },
    }));
  } else {
    setState((prev: any) => ({
      ...prev,
      ["firstName"]: { error: false, message: "" },
    }));
  }

  if (inputValue.lastName.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["lastName"]: { error: true, message: "Add Your Last Name" },
    }));
  } else {
    setState((prev: any) => ({
      ...prev,
      ["lastName"]: { error: false, message: "" },
    }));
  }

  if (inputValue.jobTitle.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["jobTitle"]: { error: true, message: "Add Your Job Title" },
    }));
  } else {
    setState((prev: any) => ({
      ...prev,
      ["jobTitle"]: { error: false, message: "" },
    }));
  }

  if (inputValue.companyName.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["companyName"]: { error: true, message: "Add Your Company Name" },
    }));
  } else {
    setState((prev: any) => ({
      ...prev,
      ["companyName"]: { error: false, message: "" },
    }));
  }

  if (inputValue.mobileNumber.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["mobileNumber"]: { error: true, message: "Add Your Mobile Number" },
    }));
  } else {
    if (inputValue.mobileNumber.length < 10) {
      setState((prev: any) => ({
        ...prev,
        ["mobileNumber"]: { error: true, message: "Invalid mobile number" },
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        ["mobileNumber"]: { error: false, message: "" },
      }));
    }
  }

  return res;
}

export function UpdatePasswordValidation(
  inputValue: any,
  inputErrorValues: any,
  setState: any
) {
  let res = "nn";
  if (inputValue.password.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["password"]: { error: true, message: "Add Your Password" },
    }));
  } else {
    setState((prev: any) => ({
      ...prev,
      ["password"]: { error: false, message: "" },
    }));
  }

  if (inputValue.newPassword.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["newPassword"]: { error: true, message: "Add Your New Password" },
    }));
  } else {
    if (!PasswordValidation(inputValue.newPassword)) {
      setState((prev: any) => ({
        ...prev,
        ["newPassword"]: {
          error: true,
          message:
            "Your Password must include One Capital letter, One Simple letter, One Special character & One numeric character",
        },
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        ["newPassword"]: { error: false, message: "" },
      }));
    }
  }

  if (inputValue.confirmPassword.length === 0) {
    setState((prev: any) => ({
      ...prev,
      ["confirmPassword"]: {
        error: true,
        message: "Confirm Your New Password",
      },
    }));
  } else {
    if (inputValue.confirmPassword !== inputValue.newPassword) {
      setState((prev: any) => ({
        ...prev,
        ["confirmPassword"]: {
          error: true,
          message: "You are entering the wrong password",
        },
      }));
    } else {
      setState((prev: any) => ({
        ...prev,
        ["confirmPassword"]: { error: false, message: "" },
      }));
    }
  }
  return res;
}
